module.exports = __webpack_public_path__ + "static/media/screenshot.855f8696.png";